import { computed, ref } from "vue";
import { isEqual } from "lodash";
import { whenever } from "@vueuse/core";

export function useIsDirty(backupData, currentData) {
    const backupRef = ref(backupData);
    const currentRef = ref(currentData);
    const isDirty = computed(() => !isEqual(backupRef.value, currentRef.value));

    whenever(isDirty, () => {
        // attach _changed flag to the backup and current data
        // but only if it is not deleted or created
        if (!currentRef.value._created && !currentRef.value._deleted) {
            currentRef.value._changed = true;
            backupRef.value._changed = true;
        }
    });

    return { isDirty };
}
